"use client";
import { createContext, useContext, useReducer, Dispatch } from "react";
import useSWR from "swr";
import axios from "axios";
import { useCartStore } from "states/cart";

type K = Record<string, number>;
type V = [string, number] | [string, number, true] | "CLEAR_CART";

const initializer: K = {};

const reducer = (state: K, action: V) => {
  if (action === "CLEAR_CART") {
    return {};
  }
  if (action[2]) {
    return {
      [action[0]]: action[1],
    };
  }
  if (state[action[0]] === action[1]) return state;
  let newState = { ...state };
  if (action[1] < 1) {
    delete newState[action[0]];
  } else {
    newState[action[0]] = action[1];
  }
  return newState;
};

let contextInitializer: [K, Dispatch<V>] | undefined = undefined;

const CartContext = createContext(contextInitializer!);

export default function CartProvider({ children }: React.PropsWithChildren) {
  const reducerArr = useReducer(reducer, initializer);

  return <CartContext.Provider value={reducerArr}>{children}</CartContext.Provider>;
}

async function fetcher(arg: [string, string[]]) {
  const { data } = await axios.post(arg[0], {
    uids: arg[1],
  });
  return data as Product[];
}

export function useCartFetch() {
  const { cart } = useCartStore();
  return useMultipleProducts(Object.keys(cart));
}

export function useMultipleProducts(list: string[]) {
  return useSWR(["/products/multiple_products_by_id/", list], fetcher);
}
